export default {
	name: 'subject-network',
	path: '/subject-network',
	redirect: '/subject-network/index',
	meta: {
		title: '教育资源库',
		icon: 'icon-home'
	},
	children: [
		{
			name: 'subject-network-index',
			path: '',
			fullPath: '/subject-network/index',
			component: () =>
				import(/* webpackChunkName: "subject-network" */ '@/views/subject-network')
		}
	]
};
